import React from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  { to: '/about', label: 'About' },
  { to: '/terms', label: 'Terms & Conditions' },
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/contact', label: 'Contact Us' },
];

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <Link to="/" className="flex items-center py-1" aria-label="Stranger69.net Home">
            <img src="/st69_logo_new.png" alt="Stranger69.net" className="h-10 w-auto object-contain brightness-0 invert" />
          </Link>
          <nav className="flex flex-wrap items-center justify-center gap-6">
            {footerLinks.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className="hover:text-white transition-colors"
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>
        <p className="mt-8 text-center text-slate-500 text-sm">
          &copy; {new Date().getFullYear()} Stranger69.net. Premium verified friend hiring platform.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
